/** Return entries for a category; "all" returns everything. Pure function. */
export function filterEntries(entries, categoryId) {
  return categoryId === "all"
    ? entries
    : entries.filter((e) => e.category === categoryId);
}
